import React from 'react';
import { motion } from 'framer-motion';
import { FaChalkboardTeacher, FaHandsHelping, FaCertificate, FaHeadset } from 'react-icons/fa';
import { staggerContainer, staggerItem } from '../../utils/animations';
import Section from '../../Components/common/Section';
import FeatureCard from '../../Components/common/FeatureCard';
import GradientText from '../../Components/common/GradientText';

const WhyChooseUs = () => {
  const features = [
    {
      icon: FaChalkboardTeacher,
      title: 'Expert AI Trainers',
      description: 'Learn from industry professionals with real-world AI implementation experience.',
    },
    {
      icon: FaHandsHelping,
      title: 'Hands-on Learning',
      description: 'Build real projects and gain practical skills that you can apply immediately.',
    },
    {
      icon: FaCertificate,
      title: 'Industry-Recognized Certifications',
      description: 'Earn certificates that showcase your AI expertise to employers and clients.',
    },
    {
      icon: FaHeadset,
      title: 'Ongoing Support',
      description: 'Get lifetime access to course materials and community support even after completion.',
    },
  ];

  return (
    <Section background="light">
      <motion.div
        variants={staggerContainer}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.2 }}
      >
        <motion.div variants={staggerItem} className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Why Choose <GradientText>RuhiTech Solutions</GradientText>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Your trusted partner in AI readiness and digital transformation
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <motion.div key={index} variants={staggerItem}>
              <FeatureCard {...feature} />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </Section>
  );
};

export default WhyChooseUs;
